import CustomMultiSelect from "../../Utilities/CustomMultiSelect";
import Modal from "../../Utilities/Modal";
import React, {useEffect, useState} from "react";
import ApiRoute from "../../../helper/api";
import {toast} from "react-toastify";
import {DatePicker} from "zaman";
import moment from "jalali-moment";
import {getTimeFromDate} from "../../../helper/general";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLineChart} from "@fortawesome/free-solid-svg-icons";
import PriceChart from "../../Utilities/PriceChart";

export default function PriceChartModel({product , closeModal}){


    const [data , setData] = useState(null)
    const [update , setUpdate] = useState(0)
    const [priceChart , setPriceChart] = useState([])
    const [datesArray , setDatesArray] = useState([])
    const [finalPricesArray , setFinalPricesArray] = useState([])

    useEffect(() => {
         getData()
    }, [update]);

    async function getData() {
        // product price chart
        const priceResponse = await ApiRoute.product.priceHistory.fn(product._id)
        if (priceResponse.status_code === 200){
            let _priceChart = priceResponse.results;

            // استخراج کلیدها به عنوان تاریخ
            let x = Object.keys(_priceChart).map(key => key.split(' ')[0]);
            const currentDate = new Date().toISOString().split('T')[0];
            x.push(currentDate);
            
            // تبدیل رشته‌های تاریخ به آبجکت‌های Date برای مرتب‌سازی صحیح
            const dateObjects = x.map(dateStr => new Date(dateStr));
            
            // مرتب‌سازی تاریخ‌ها از قدیمی به جدید
            dateObjects.sort((a, b) => a - b);
            
            // تبدیل دوباره به رشته‌های تاریخ در فرمت YYYY-MM-DD
            const sortedDates = dateObjects.map(date => 
                date.toISOString().split('T')[0]
            );
            
            // معکوس کردن آرایه تاریخ‌ها (از جدید به قدیم)
            const reversedDates = [...sortedDates].reverse();
            setDatesArray(reversedDates);

            // ایجاد یک آرایه مرتب‌شده از مقادیر با همان ترتیب تاریخ‌های مرتب‌شده
            const sortedValues = [];
            
            // ابتدا تمام مقادیر را با کلیدهای مربوطه جمع‌آوری می‌کنیم
            for (let i = 0; i < sortedDates.length - 1; i++) {
                const dateKey = sortedDates[i];
                // پیدا کردن کلید کامل در _priceChart که با این تاریخ شروع می‌شود
                const fullKey = Object.keys(_priceChart).find(key => key.startsWith(dateKey));
                
                if (fullKey) {
                    sortedValues.push(_priceChart[fullKey]);
                } else {
                    // اگر تاریخ در _priceChart موجود نباشد (مثلاً برای تاریخ امروز)،
                    // از آخرین مقدار موجود استفاده می‌کنیم
                    sortedValues.push(sortedValues[sortedValues.length - 1] || {
                        regular: 0,
                        sale: 0,
                        price: 0,
                        stock_web_site: 0
                    });
                }
            }
            
            // برای تاریخ امروز (آخرین تاریخ)، از آخرین مقدار موجود استفاده می‌کنیم
            sortedValues.push(sortedValues[sortedValues.length - 1] || {
                regular: 0,
                sale: 0,
                price: 0,
                stock_web_site: 0
            });
            
            // معکوس کردن آرایه‌ی مقادیر مرتب شده
            const reversedValues = [...sortedValues].reverse();
            
            // استخراج داده‌های مورد نیاز از مقادیر مرتب‌شده و معکوس شده
            const reversedRegularPrices = reversedValues.map(entry => entry.regular);
            const reversedSalePrices = reversedValues.map(entry => entry.sale);
            const reversedPrices = reversedValues.map(entry => entry.price);
            const reversedStockStatus = reversedValues.map(entry => entry.stock_web_site);
            
            setFinalPricesArray({ 
                regular: reversedRegularPrices, 
                sale: reversedSalePrices, 
                price: reversedPrices,
                stock: reversedStockStatus 
            });

            setData(priceResponse);
        }
    }


    return (
        <Modal isOpen={true} onClose={closeModal} classes="">
            <div className="page-title z-1 mb-3 text-13"><span
                className="inline-block text-purple-1 bg-white pl-3 z-2 relative">
                    <FontAwesomeIcon className="ml-1" icon={faLineChart}/>
                    نمودار تغییرات قیمت
                </span>
            </div>
            <p className="text-xs text-gray-10 border-b border-b-gray-7 pb-2">{product.title}</p>
            <div className="flex justify-end gap-5 text-xs">
                        <span className="flex items-center gap-1 text-gray-10">
                            موجود
                            <div className="relative flex items-center">
                                 <span className="inline-block w-5 h-0.5 bg-purple-1 rounded-full"></span>
                                 <span className="inline-block w-1.5 h-1.5 bg-purple-1 rounded-full absolute inset-0 mx-auto top-[-2px]"></span>
                            </div>
                        </span>
                <span className="flex items-center gap-1 text-gray-10">
                            ناموجود
                              <div className="relative flex items-center">
                                 <span className="inline-block w-5 h-0.5 bg-gray-10 rounded-full"></span>
                                 <span className="inline-block w-1.5 h-1.5 bg-gray-10 rounded-full absolute inset-0 mx-auto top-[-2px]"></span>
                            </div>
                        </span>
                <span className="flex items-center gap-1 text-gray-10">
                            تخفیف
                            <span className="inline-block w-1.5 h-1.5 bg-red-1 rounded-full">
                            </span>
                        </span>
            </div>

            {data && <PriceChart 
                labels={datesArray} 
                regularPrices={finalPricesArray.regular} 
                salePrices={finalPricesArray.sale} 
                prices={finalPricesArray.price}
                stockStatus={finalPricesArray.stock}
            />}

        </Modal>
    )
}